export const company = {
  legalName: 'Futuramy Investment LLC',
  businessName: 'Futuramy LLC',
  wordmark: 'FUTURAMY',
  entity: 'Limited Liability Company',
  addressLine1: '1600 SW 78th Ave',
  addressLine2: 'Plantation, Florida 33324',
  addressLine3: 'United States',
  city: 'Plantation, Florida, United States',
  phone: '+57 3152076625',
  phoneHref: 'tel:+573152076625',
  lastUpdated: 'Last Updated: August 2026',
}

export const disclaimer =
  'The information provided on this website is for general informational purposes only and does not constitute financial, legal, tax or investment advice.'

export const footerDisclaimer =
  'Information on this website is provided for general informational purposes only.'

export const copyright = '© 2026 Futuramy Investment LLC. All rights reserved.'

export const navLinks = [
  { label: 'Home', to: '/' },
  { label: 'About', to: '/about' },
  { label: 'Business Focus', to: '/business-focus' },
  { label: 'Approach', to: '/approach' },
  { label: 'Contact', to: '/contact' },
]

export const footerLinks = [
  { label: 'About', to: '/about' },
  { label: 'Business Focus', to: '/business-focus' },
  { label: 'Approach', to: '/approach' },
  { label: 'Contact', to: '/contact' },
  { label: 'Privacy Policy', to: '/privacy-policy' },
  { label: 'Terms of Use', to: '/terms-of-use' },
]

export const images = {
  hero: 'https://cdn.magicpatterns.com/patterns/generated-images/5198a6e3-9638-4ec7-9dca-2deb5750adb7.jpg',
  about: 'https://cdn.magicpatterns.com/patterns/generated-images/d16dd773-ea2e-4887-9482-a57132d8e6bc.jpg',
  focus: 'https://cdn.magicpatterns.com/patterns/generated-images/4a24a9a1-e1f5-4f3b-9732-c56b85e4c614.jpg',
  approach: 'https://cdn.magicpatterns.com/patterns/generated-images/34befd23-34fe-47f6-b10b-d886eb388904.jpg',
}

export const introFeatures = [
  {
    number: '01',
    title: 'Strategic Thinking',
    description: 'Evaluating opportunities with a thoughtful and disciplined perspective.',
  },
  {
    number: '02',
    title: 'Long-Term Perspective',
    description: 'Focusing on sustainable opportunities rather than short-term outcomes.',
  },
  {
    number: '03',
    title: 'Responsible Growth',
    description: 'Building business initiatives with clarity, consistency and long-term value in mind.',
  },
]

export const businessFocusCards = [
  {
    number: '01',
    title: 'Strategic Opportunities',
    short: 'We evaluate opportunities that align with our long-term business perspective.',
    detailed:
      'We identify and evaluate opportunities based on their potential, strategic relevance and long-term considerations.',
  },
  {
    number: '02',
    title: 'Business Development',
    short: 'We support initiatives designed to create sustainable business opportunities and growth.',
    detailed:
      'We support business initiatives and projects with a focus on sustainable development and practical execution.',
  },
  {
    number: '03',
    title: 'Strategic Relationships',
    short: 'We value professional relationships built on transparency, trust and mutual value.',
    detailed:
      'We seek to establish professional relationships that can create meaningful and sustainable business opportunities.',
  },
]

export const approachSteps = [
  {
    number: '01',
    title: 'Identify',
    short: 'We identify opportunities and areas with potential for long-term value.',
    detailed: 'Understanding the opportunity and the broader business environment.',
  },
  {
    number: '02',
    title: 'Evaluate',
    short: 'We consider the potential, risks and broader business context of each opportunity.',
    detailed: 'Considering potential, risks, strategic fit and long-term implications.',
  },
  {
    number: '03',
    title: 'Develop',
    short: 'We work toward practical initiatives and strategic relationships.',
    detailed: 'Turning promising opportunities into structured business initiatives.',
  },
  {
    number: '04',
    title: 'Build',
    short: 'We focus on sustainable business development and long-term value creation.',
    detailed: 'Creating sustainable relationships and long-term business value.',
  },
]

export const principles = [
  {
    title: 'Clarity',
    description: 'We seek to approach opportunities with clear objectives and thoughtful evaluation.',
  },
  {
    title: 'Integrity',
    description: 'We value transparent and professional business relationships.',
  },
  {
    title: 'Long-Term Thinking',
    description: 'We focus on sustainable opportunities and responsible business development.',
  },
]
